import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// component items
import { CoreNotificationsHelpersActionRecordStartComponent } from './record-start/record-start.component';
import { CoreNotificationsHelpersActionFileCompressionStartComponent } from './file-compression-start/file-compression-start.component';
import { CoreNotificationsHelpersActionFileAnnotationsStartComponent } from './file-with-annotations-start/file-with-annotations-start.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        CoreNotificationsHelpersActionRecordStartComponent,
        CoreNotificationsHelpersActionFileCompressionStartComponent,
        CoreNotificationsHelpersActionFileAnnotationsStartComponent
    ],
    exports: [
        CoreNotificationsHelpersActionRecordStartComponent,
        CoreNotificationsHelpersActionFileCompressionStartComponent,
        CoreNotificationsHelpersActionFileAnnotationsStartComponent
    ],

})
export class CoreNotificationsHelpersActionsModule { }
// Module for notification helpers components for each action notification